export const INVOICE_TABLE_HEADERS = [
  {
    text: 'entities.invoices.attributes.number',
    value: 'number',
    sortable: false,
    width: 150,
  },
  {
    text: 'entities.invoices.attributes.toUser',
    value: 'buyer_user_id',
    sortable: false,
    width: 250,
  },
  {
    text: 'miscellaneous.gross',
    value: 'total_gross_amount',
    sortable: false,
    width: 120,
  },
  {
    text: 'miscellaneous.manualDiscount',
    value: 'manual_discount_amount',
    sortable: false,
    width: 130,
  },
  {
    text: 'miscellaneous.createdAt',
    value: 'created_at',
    sortable: false,
    width: 200,
  },
  {
    text: 'entities.invoices.attributes.fiscalized',
    value: 'fiscalized',
    sortable: false,
    width: 90,
  },
  {
    text: 'entities.paymentMethods.entity',
    value: 'payment_method_id',
    sortable: false,
    width: 130,
  },
  {
    text: 'miscellaneous.actions',
    value: 'actions',
    sortable: false,
    width: 240,
  },
]
